module.exports = __webpack_public_path__ + "static/media/play_tournament.7e442a40.png";